import OverviewTabs from './OverviewTabs';

export default OverviewTabs;
